import { jsx as e } from "react/jsx-runtime";
import { MenuItem as u } from "@chakra-ui/react";
const I = ({ children: m, as: r, href: t, isDisabled: o, ...n }) => /* @__PURE__ */ e(
  u,
  {
    isDisabled: o,
    as: o ? void 0 : r,
    href: o ? void 0 : t,
    to: !o && t ? t : void 0,
    ...n,
    children: m
  }
);
export {
  I as MenuItem
};
